const ConfirmCancelSubscription = ({ handleCancelSubscription, handleCancel }) => {
  return (
    <>
  <div className="p-6 animate-scale-in">
    {/* Icon */}
    <div className="flex justify-center mb-4">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center animate-pulse-slow">
        <svg 
          className="w-8 h-8 text-red-600" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
          />
        </svg>
      </div>
    </div>

    {/* Title */}
    <h3 className="text-xl font-bold text-black text-center mb-2">
      Cancel Subscription?
    </h3>

    {/* Message */}
    <p className="text-base text-gray-700 text-center mb-6 max-w-md mx-auto">
      Are you sure you want to cancel your subscription? You'll lose access to all premium features at the end of your billing period.
    </p>

    {/* Buttons */}
    <div className="flex flex-col sm:flex-row justify-center gap-3 w-full">
      <button
        onClick={() => handleCancel()}
        className="flex-1 sm:flex-none px-6 py-3 bg-primary hover:bg-primary text-gray-700 font-semibold rounded-lg border border-gray-300 transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-sm hover:shadow-md"
      >
        Keep Subscription
      </button>
      <button
        onClick={() => handleCancelSubscription()}
        className="flex-1 sm:flex-none px-6 py-3 bg-red-600 hover:bg-red-700 text-black font-semibold rounded-lg border border-red-700 transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg"
      >
        Yes, Cancel
      </button>
    </div>

    {/* Additional Info */}
    <p className="text-xs text-gray-500 text-center mt-4">
      Your subscription will remain active until the end of the current billing period
    </p>
  </div>

  <style jsx>{`
    @keyframes scale-in {
      from {
        opacity: 0;
        transform: scale(0.95);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    @keyframes pulse-slow {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }

    .animate-scale-in {
      animation: scale-in 0.3s ease-out;
    }

    .animate-pulse-slow {
      animation: pulse-slow 2s ease-in-out infinite;
    }
  `}</style>
</>
  );
};

export default ConfirmCancelSubscription;